import { ProCard } from '@ant-design/pro-components';
import { CardTitleWithIcon } from '@ohpen/enso-ui';

export type CrudFormCardProps = {
  children: React.ReactNode;
  icon: React.ReactNode;
  title: string;
};

export const CrudFormCard = ({ children, icon, title }: CrudFormCardProps) => {
  return (
    <ProCard key="firm-card" title={<CardTitleWithIcon icon={icon} title={title} />} bordered headerBordered size="small">
      {children}
    </ProCard>
  );
};
